"use client";

import { c as _c } from "react/compiler-runtime";
import { Check, MessageSquareDashed } from "lucide-react";
import { AnimatePresence, motion } from "motion/react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
interface TempChatSwitcherProps {
  isTemporaryChat: boolean;
  onToggleTemporaryChat: () => void;
  isTemporaryChatToggleDisabled: boolean;
  hasTemporaryMessages: boolean;
}
export function TempChatSwitcher(t0) {
  const $ = _c(28);
  const {
    isTemporaryChat,
    onToggleTemporaryChat,
    isTemporaryChatToggleDisabled,
    hasTemporaryMessages
  } = t0;
  let t1;
  if ($[0] !== isTemporaryChat) {
    t1 = isTemporaryChat ? {
      scale: [1, 1.12, 1],
      rotate: [0, -8, 0]
    } : {
      scale: 1,
      rotate: 0
    };
    $[0] = isTemporaryChat;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      duration: 0.32,
      ease: "easeOut"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MessageSquareDashed className="size-4" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isTemporaryChat) {
    t4 = isTemporaryChat ? <motion.span key="temporary-check" initial={{
      scale: 0.45,
      opacity: 0,
      rotate: -18
    }} animate={{
      scale: 1,
      opacity: 1,
      rotate: 0
    }} exit={{
      scale: 0.45,
      opacity: 0,
      rotate: 18
    }} transition={{
      duration: 0.16,
      ease: "easeOut"
    }} className="absolute inset-0 flex items-center justify-center"><Check className="size-2.5 stroke-[3]" /></motion.span> : null;
    $[4] = isTemporaryChat;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <span className="relative flex size-4 items-center justify-center">{t3}<AnimatePresence initial={false}>{t4}</AnimatePresence></span>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isTemporaryChatToggleDisabled || $[9] !== onToggleTemporaryChat || $[10] !== t5) {
    t6 = <Button type="button" variant="ghost" size="icon-sm" onClick={onToggleTemporaryChat} disabled={isTemporaryChatToggleDisabled} className="bg-transparent" aria-label="Toggle temporary chat">{t5}</Button>;
    $[8] = isTemporaryChatToggleDisabled;
    $[9] = onToggleTemporaryChat;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t6) {
    t7 = <TooltipTrigger asChild={true}><motion.div animate={t1} transition={t2}>{t6}</motion.div></TooltipTrigger>;
    $[12] = t1;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = isTemporaryChat ? "Temporary chat is on" : "Start temporary chat";
  let t9;
  if ($[15] !== t8) {
    t9 = <TooltipContent>{t8}</TooltipContent>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7 || $[18] !== t9) {
    t10 = <Tooltip>{t7}{t9}</Tooltip>;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== hasTemporaryMessages || $[21] !== isTemporaryChat) {
    t11 = isTemporaryChat && hasTemporaryMessages ? <motion.span key="temporary-chat-label" initial={{
      opacity: 0,
      x: -6
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -6
    }} transition={{
      duration: 0.18
    }} className="text-xs text-muted-foreground hidden sm:inline">Temporary Chat</motion.span> : null;
    $[20] = hasTemporaryMessages;
    $[21] = isTemporaryChat;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = <AnimatePresence initial={false}>{t11}</AnimatePresence>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t12) {
    t13 = <>{t10}{t12}</>;
    $[25] = t10;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}